export const blockBodyScroll = () => {
  document.body.classList.add("!overflow-hidden");
};

export const releaseBodyScroll = () => {
  document.body.classList.remove("!overflow-hidden");
};
